import { render, staticRenderFns } from "./diagnosisTime.vue?vue&type=template&id=3db27371&scoped=true"
import script from "./diagnosisTime.vue?vue&type=script&lang=ts"
export * from "./diagnosisTime.vue?vue&type=script&lang=ts"
import style0 from "./diagnosisTime.vue?vue&type=style&index=0&id=3db27371&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db27371",
  null
  
)

export default component.exports